<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import proveedorContratistaAPI from "@/services/standards/crearProveedorContratista/proveedorContratistaAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormatYear } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Crear proveedor",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {

    return {
      title: "2.9.1-1 Crear proveedor",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Crear proveedor",
          active: true,
        },
      ],

      lista: [],
      file: null,
      loading: true,
      acta: null,

      item: null,
      itemStatus: null,
      submitted: false,
      search: "",

      itemData: null,

      revisionAnual: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      proveedorContratista: {
        name: null,
        identification_type_id: null,
        number_identification: null,
        dv: null,
        email: null,
        type: null,
        telephone: null,
        initial_date: null,
        final_date: null,
        status: '1',
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      tipoDocumento: [
        {
          id: 1,
          nombre: "Cedula de ciudadania"
        },
        {
          id: 2,
          nombre: "Tarjeta de identidad"
        },
        {
          id: 3,
          nombre: "Cedula de extranjeria"
        },
        {
          id: 4,
          nombre: "Permiso especial de permanencia"
        },
        {
          id: 5,
          nombre: "Permiso de proteccion temporal"
        },
        {
          id: 6,
          nombre: "NIT"
        },
      ],

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(55)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    validarNumero() {
      // Verificar si el valor ingresado es mayor a 1 carácter
      if (this.proveedorContratista.dv && (this.proveedorContratista.dv === "e" || this.proveedorContratista.dv.toString().length > 1)) {
        // Si es mayor, truncar a 1 carácter
        this.proveedorContratista.dv = null;
      }
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormatYear(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 55)
        .then(response => {
          this.item = response || null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getList() {
      proveedorContratistaAPI.getAll()
        .then((response) => {
          this.loading = false
          let proveedorC = response.data.data;
          this.lista = proveedorC
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    save() {
      this.submitted = true
      this.loading = true
      proveedorContratistaAPI.save(this.proveedorContratista)
        .then((response) => {
          this.sendNotification(40, 55, true)
          this.loading = false
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha registrado con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    deleteRevision(id) {
      proveedorContratistaAPI.deleteRevision(id)
        .then((data) => {
          Swal.fire({
            title: "Éxito!",
            text: "Se ha sido eliminado con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActa() {
      revisionAnualAPI.getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        revisionAnualAPI.getActa()
          .then((response) => {
            this.acta = response;
          })
        const url = this.acta;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Tanto el Decreto 1072/2015 como la resolución 0312 de 2019 exigen que las empresas cuenten con
                      especificaciones de SST para las adquisiciones de bienes y servicios, esto implica que la empresa
                      debe definir dependiendo del producto / servicio adquirido, que criterios desde Seguridad y Salud
                      en el Trabajo debe cumplir ese proveedor para ser seleccionado.
                    </p>
                    <p class="text-justify">
                      En el link ESPECIFICACIONES DE SST, se describe algunos de los requisitos de SST para las
                      adquisiciones, los cuales servirán de guía para la empresa.
                    </p>
                    <p class="text-justify">
                      En el ítem 2.10.1 se seleccionará el proveedor y el que sea escogido, deberá crearse con la
                      información aquí solicitada.
                    </p>
                    <p class="text-justify">
                      Se debe subir al aplicativo la evidencia del cumplimiento de las especificaciones de SST del
                      proveedor.
                    </p>
                  </CheckModal>
                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>

              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <div class="col-md-12">
                    <div class="form-row">
                      <b-form-group class="col-md-6 px-2" label="Nombre completo" label-for="name">
                        <b-form-input type="text" id="name" maxlength="100" v-model="proveedorContratista.name"
                          requiered>
                        </b-form-input>
                      </b-form-group>

                      <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row ml-5 mt-4">
                        <b-form-radio v-model="proveedorContratista.type" :aria-describedby="ariaDescribedby"
                          name="some-radio" value=1>Proveedor</b-form-radio>

                      </b-form-group>
                      <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row mt-4">

                        <b-form-radio v-model="proveedorContratista.type" :aria-describedby="ariaDescribedby"
                          name="some-radio" value=2>Contratista</b-form-radio>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-row">
                      <b-form-group class="col-md-6 px-2" label="Tipo de identificación" label-for="iden">
                        <select id="iden" class="form-control" v-model="proveedorContratista.identification_type_id"
                          requiered>
                          <option v-for="item in tipoDocumento" :value="item.id" :key="item.id">
                            {{ item.nombre }}
                          </option>
                        </select>
                      </b-form-group>

                      <b-form-group class="col-md-6 px-2" label="Número de identificación" label-for="Nid">
                        <b-form-input maxlength="20" v-model="proveedorContratista.number_identification"
                          onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text" id="Nid"
                          requiered>
                        </b-form-input>
                      </b-form-group>

                      <b-form-group v-if="proveedorContratista.identification_type_id === 6" class="col-md-6 px-2"
                        label="Dígito de verificación" label-for="dv">
                        <input type="text" id="dv" v-model="proveedorContratista.dv" @input="validarNumero"
                          maxlength="1" class="form-control">
                      </b-form-group>

                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-row">
                      <b-form-group class="col-md-6 px-2" label="Email personal" label-for="personal_email">
                        <b-form-input type="text" id="personal_email" v-model="proveedorContratista.email" requiered>
                        </b-form-input>
                      </b-form-group>
                      <b-form-group class="col-md-6 px-2" label="Teléfono" label-for="phone1">
                        <b-form-input maxlength="10" v-model="proveedorContratista.telephone"
                          onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" type="text" id="phone_1"
                          requiered>
                        </b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <div class="col-md-12 pb-0 m-0">
                    <div class="form-row">
                      <b-form-group class="col-md-6 px-2" label="Fecha de inicio" label-for="contract_start_date">
                        <b-form-input type="date" v-model="proveedorContratista.initial_date" id="contract_start_date"
                          requiered>
                        </b-form-input>
                      </b-form-group>

                      <b-form-group class="col-md-6 px-2" label="Fecha fin" label-for="contract_end_date">
                        <b-form-input :disabled="proveedorContratista.status != 2" type="date" id="contract_end_date"
                          v-model="proveedorContratista.final_date" requiered>
                        </b-form-input>
                      </b-form-group>
                    </div>
                  </div>

                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row ml-5 mt-4">
                    <b-form-radio v-model="proveedorContratista.status" :aria-describedby="ariaDescribedby"
                      name="some-radios" value=1>Activo</b-form-radio>

                  </b-form-group>
                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row mt-4">

                    <b-form-radio v-model="proveedorContratista.status" :aria-describedby="ariaDescribedby"
                      name="some-radios" value=2>Inactivo</b-form-radio>
                  </b-form-group>

                </div>
                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>


                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Nombre</th>
                              <th class="text-center align-middle">Tipo</th>
                              <th class="text-center align-middle">Documento</th>
                              <th class="text-center align-middle">Email</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">{{ dato.name }}</td>
                              <td class="text-center align-middle">
                                {{ dato.type }}
                              </td>
                              <td class="text-center align-middle">{{ dato.number_identification }}</td>

                              <td class="text-center align-middle">{{ dato.email }}</td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')"
                                      :to="{ path: `/forms/estandares/crear-colaborador-editar/${dato.id}` }">
                                      Editar
                                    </b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteRevision(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>

                        </table>

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>

              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>